import {
    ecsApi,
    GetWorksiteConsumptionResponse,
    GetWorksiteConsumptionPayload,
    GetWorksiteProgressResponse,
    GetWorksiteProgressPayload,
    GetWorksiteInfoResponse
} from '@services';

export const worksitesApi = ecsApi.injectEndpoints({
    endpoints: (builder) => ({
        getWorksiteConsumption: builder.mutation<GetWorksiteConsumptionResponse, GetWorksiteConsumptionPayload>({
            query: ({ worksiteId }) => ({
                url: `/worksites/${worksiteId}/consumption`,
                method: 'GET'
            })
        }),
        getWorksiteProgress: builder.mutation<GetWorksiteProgressResponse, GetWorksiteProgressPayload>({
            query: ({ worksiteId }) => ({
                url: `/worksites/${worksiteId}/progress`,
                method: 'GET'
            })
        }),
        getWorksiteInfo: builder.query<GetWorksiteInfoResponse, string>({
            query: (worksiteId) => ({
                url: `/worksites/${worksiteId}`,
                method: 'GET'
            })
        }),
        getWorksiteInfoMutation: builder.mutation<GetWorksiteInfoResponse, string>({
            query: (worksiteId) => ({
                url: `/worksites/${worksiteId}`,
                method: 'GET'
            })
        })
    })
});

export const {
    useGetWorksiteConsumptionMutation,
    useGetWorksiteProgressMutation,
    useGetWorksiteInfoQuery,
    useGetWorksiteInfoMutationMutation: useGetWorksiteInfoMutation
} = worksitesApi;
